import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from "../../Services/translation";
import CheckoutCartItem from "./CheckoutCartItem";

const CheckoutCart = ({ onClick }) => {
    const cart = useSelector((state) => state.cart);

    return (
        <div>
            <p className="checkout__heading">{translate('checkout.cart')}</p>
            <div className="card">
                <div className="card__body card__body--paddingless">
                    <div>

                        <div>
                            <div>

                            </div>
                            <ul className="checkout__article-list">
                                {
                                    cart.orderRows.map((x, index) => {
                                            return (<li className="checkout__article-container" key={index}>
                                                <CheckoutCartItem article={x}/>
                                            </li>)
                                        }
                                    )
                                }
                                <li className="checkout__article-container">
                                    <p className="checkout__article-total-price">{cart.orderTotal}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckoutCart;
